import { t } from "@/i18n";

export default {
    namespaced: true,
    getters: {
        pageColors: (s, g, rootState) => {
            return [
                {
                    value: "var(--et-colors-brand)",
                    hex: rootState.page.page.colors.brand,
                    label: t("shared.colors.brand"),
                },
                {
                    value: "var(--et-colors-background)",
                    hex: rootState.page.page.colors.background,
                    label: t("shared.colors.background"),
                },
                {
                    value: "var(--et-colors-text)",
                    hex: rootState.page.page.colors.text,
                    label: t("shared.colors.text"),
                },
                {
                    value: "var(--et-colors-card-background)",
                    hex: rootState.page.page.colors.cardBackground,
                    label: t("shared.colors.card_background"),
                },
                {
                    value: "var(--et-colors-card-text)",
                    hex: rootState.page.page.colors.cardText,
                    label: t("shared.colors.card_text"),
                },
                {
                    value: "var(--et-colors-border)",
                    hex: rootState.page.page.colors.border,
                    label: t("shared.colors.border"),
                },
            ];
        },
        pageColorsStyles: (_, { pageColors }) => ({
            "--et-colors-brand": pageColors.find(({ value }) => value === "var(--et-colors-brand)")
                ?.hex,
            "--et-colors-background": pageColors.find(
                ({ value }) => value === "var(--et-colors-background)"
            )?.hex,
            "--et-colors-text": pageColors.find(({ value }) => value === "var(--et-colors-text)")
                ?.hex,
            "--et-colors-card-background": pageColors.find(
                ({ value }) => value === "var(--et-colors-card-background)"
            )?.hex,
            "--et-colors-card-text": pageColors.find(
                ({ value }) => value === "var(--et-colors-card-text)"
            )?.hex,
        }),
    },
    actions: {
        changeColorTheme({ rootState, dispatch }, { theme }) {
            const pageModule = rootState.page;
            pageModule.page.theme = String(theme.id);
            pageModule.page.colors = {
                brand: theme.colors.brand,
                background: theme.colors.background,
                text: theme.colors.text,
                cardBackground: theme.colors.cardBackground,
                cardText: theme.colors.cardText,
                border: theme.colors.border,
            };
            dispatch("page/refreshIframe", null, { root: true });
        },
        changeStyleTheme({ rootState, dispatch }, style) {
            const pageModule = rootState.page;
            pageModule.page.styleTheme = style.id;
            pageModule.page.fontFamily = style.font;
            dispatch("page/refreshIframe", null, { root: true });
        },
    },
};
